import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { AuthContext } from '../../context';

import PageTitle from '../../components/shared/page-title';
import Feeds from '../../components/shared/feeds';
import QuestionsForYou from '../../components/home/questions';
import NewQuestionForm from '../../components/forms/new-question';
import Modal from '../../components/shared/modal';

import style from './index.module.scss';

class HomePage extends Component {
  static contextType = AuthContext;

  state = {
    open: false,
  };
 
  onOpenModal = () =>
    this.setState({
      open: true,
    });

  onCloseModal = () =>
    this.setState({
      open: false,
    });

  render() {
    const { open } = this.state;
    const { currentUser } = this.context;
    const { card, img, heading, link } = style;

    return (
      <>
        <PageTitle pageTitle='Quora - Home' pageDesc='Home page of Quora' />
        <Feeds>
          {!open && currentUser ? (
            <div className={`card ${card}`}>
              <Link
                to={{
                  pathname: `/account/${currentUser.fullname}`,
                  state: {
                    userId: currentUser.id,
                  },
                }}
                className={link}
              >
                <span className={style['profile-img']}>
                  <img
                    src={currentUser.imgUrl || 'https://i.imgur.com/qHpJwKV.jpg'}
                    alt={currentUser.fullname}
                    className={img}
                  />
                </span>{' '}
                <span className={style['profile-name']}>
                  {currentUser.fullname}
                </span>
              </Link>
              <h3
                className={`text-muted ${heading}`}
                onClick={this.onOpenModal}
              >
                What is your question?
              </h3>
            </div>
          ) : (
            <Modal
              isModalOpen={open}
              isFooterDisplayed={false}
              openModal={this.onOpenModal}
              closeModal={this.onCloseModal}
              label='Add Question'
            >
              <NewQuestionForm
                openModal={this.onOpenModal}
                closeModal={this.onCloseModal}
              />
            </Modal>
          )}
          <QuestionsForYou />
        </Feeds>
      </>
    );
  }
}

export default HomePage;
